import React from 'react';
import { ProgressHero as ProgressHeroType } from '../salesRepDashboardTypes';
import styles from './ProgressHero.module.css';

interface ProgressHeroProps {
  data: ProgressHeroType;
}

export const ProgressHero: React.FC<ProgressHeroProps> = ({ data }) => {
  return (
    <div className={styles.card}>
      <div className={styles.left}>
        <p className={styles.label}>Today's Progress</p>
        <h2 className={styles.value}>{data.todayProgress}</h2>
        <div className={styles.metaRow}>
          <span className={styles.metaItem}>✓ {data.storesVisited} stores visited</span>
          <span className={styles.metaItem}>📅 {data.appointmentsScheduled} appointments scheduled</span>
        </div>
      </div>
      <div className={styles.right}>
        <p className={styles.weeklyLabel}>Weekly Target</p>
        <h2 className={styles.weeklyValue}>{data.weeklyTarget}</h2>
        <p className={styles.weeklyMeta}>{data.remaining}</p>
        <div className={styles.progressBar}>
          <span className={styles.progressFill} style={{ width: `${data.progressPct}%` }} />
        </div>
      </div>
    </div>
  );
};
